import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPicaModule } from 'ngx-pica';

import { AppComponent } from './app.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { HttpClientModule } from '@angular/common/http';
import { ClasseurComponent } from './classeur/classeur.component';
import { IntercalairesComponent } from './intercalaires/intercalaires.component';
import { ButtonComponent } from './button/button.component';
import { BaseModalComponent } from './base-modal/base-modal.component';
import { CreateWordCategoryComponent } from './modals/create-word-category/create-word-category.component';
import { CreatePatientComponent } from './modals/create-patient/create-patient.component';
import { SignInComponent } from './sign-in/sign-in.component';
import {
    UserService,
    PatientService,
    AidantService,
    LexiboxService,
    IntercalaireService,
    CategoryService,
    SearchLexiboxService,
    FAQService
} from './_services';
import { DashboardSidebarComponent } from './dashboard/dashboard-sidebar/dashboard-sidebar.component';
import { DashboardPeopleListComponent } from './dashboard/dashboard-people-list/dashboard-people-list.component';
import { DashboardAbeillesComponent } from './dashboard/dashboard-abeilles/dashboard-abeilles.component';
import { DashboardArchivesComponent } from './dashboard/dashboard-archives/dashboard-archives.component';
import { ProfileComponent } from './profile/profile.component';
import { GoDashboardComponent } from './go-dashboard/go-dashboard.component';
import { LexiboxComponent } from './lexibox/lexibox.component';
import { CreateLexiboxComponent } from './modals/create-lexibox/create-lexibox.component';
import { FormsModule } from '@angular/forms';
import { CreateAbeilleComponent } from './modals/create-abeille/create-abeille.component';
import { AddAidantComponent } from './modals/add-aidant/add-aidant.component';
import { EvolutionComponent } from './evolution/evolution.component';
import { CreateWordComponent } from './modals/create-word/create-word.component';
import { CreateIntercalaireComponent } from './modals/create-intercalaire/create-intercalaire.component';
import { CreateCategoryComponent } from './modals/create-category/create-category.component';
import { EditCategoryComponent } from './modals/edit-category/edit-category.component';
import {WordService} from './_services/word.service';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CarouselComponent, CarouselItemElement} from './carousel/carousel.component';
import {CarouselItemDirective} from './carousel/carousel-item.directive';
import { ShowWordComponent } from './modals/show-word/show-word.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CreateAbeilleChoiceComponent } from './modals/create-abeille-choice/create-abeille-choice.component';
import { CreateAbeilleAidantComponent } from './modals/create-abeille-aidant/create-abeille-aidant.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import {DragDropDirective} from './drag-drop.directive';
import { ExercicesComponent } from './exercices/exercices.component';
import { EditAbeilleComponent } from './modals/edit-abeille/edit-abeille.component';
import { ShowPatientComponent } from './modals/show-patient/show-patient.component';
import { NoPortraitComponent } from './no-portrait/no-portrait.component';
import { MoveWordComponent } from './modals/move-word/move-word.component';
import { LexiboxInfoComponent } from './modals/lexibox-info/lexibox-info.component';
import { ImportComponent } from './import/import.component';
import { DeleteWordComponent } from './modals/delete-word/delete-word.component';
import { DashboardFaqComponent } from './dashboard/dashboard-faq/dashboard-faq.component';
import { NoEdgeComponent } from './modals/no-edge/no-edge.component';

const appRoutes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'dashboard',
        redirectTo: '/dashboard/mes-abeilles',
        pathMatch: 'full'
    },
    { path: 'dashboard/mes-abeilles', component: DashboardAbeillesComponent },
    { path: 'dashboard/archives', component: DashboardArchivesComponent },
    { path: 'dashboard/faq', component: DashboardFaqComponent },

    { path: 'profile', component: ProfileComponent },
    { path: 'evolution', component: EvolutionComponent },
    { path: 'exercices', component: ExercicesComponent },
    { path: 'classeur', component: ClasseurComponent },
    { path: 'lexibox', component: LexiboxComponent },
    { path: 'import', component: ImportComponent },
    /*{ path: '**', component: PageNotFoundComponent }*/
];

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(appRoutes),
    DragDropModule,
    NgxPicaModule
  ],
  declarations: [
    AppComponent,
    TopBarComponent,
    ClasseurComponent,
    IntercalairesComponent,
    ButtonComponent,
    BaseModalComponent,
    CreateWordCategoryComponent,
    CreatePatientComponent,
    SignInComponent,
    DashboardSidebarComponent,
    DashboardPeopleListComponent,
    DashboardAbeillesComponent,
    DashboardArchivesComponent,
    ProfileComponent,
    GoDashboardComponent,
    LexiboxComponent,
    CreateLexiboxComponent,
    CreateAbeilleComponent,
    AddAidantComponent,
    EvolutionComponent,
    CreateWordComponent,
    CreateIntercalaireComponent,
    CreateCategoryComponent,
    EditCategoryComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    ShowWordComponent,
    CreateAbeilleChoiceComponent,
    CreateAbeilleAidantComponent,
    LoginComponent,
    LogoutComponent,
    DragDropDirective,
    ExercicesComponent,
    EditAbeilleComponent,
    ShowPatientComponent,
    NoPortraitComponent,
    MoveWordComponent,
    LexiboxInfoComponent,
    ImportComponent,
    DeleteWordComponent,
    DashboardFaqComponent,
    NoEdgeComponent,
  ],
  providers: [
      PatientService,
      UserService,
      AidantService,
      IntercalaireService,
      LexiboxService,
      CategoryService,
      SearchLexiboxService,
      WordService,
      FAQService,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
